import { createFileRoute } from '@tanstack/react-router';
import { getClaimsOptions } from '../../../../features/customer/claims/queryOptions';
import { ClaimsTable } from '../../../../features/customer/claims/table';
import { validateSearch } from '../../../../utils/pagination';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/_layout/claims',
)({
  component: Page,
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: ({ context: { queryClient }, deps: { page }, params: { guid } }) =>
    queryClient.ensureQueryData(getClaimsOptions(guid, { page })),
  validateSearch: validateSearch,
});

function Page() {
  const data = Route.useLoaderData();

  return (
    <div className="col-span-full flex items-center justify-between">
      <ClaimsTable claims={data} />
    </div>
  );
}
